// Feature keys must match the backend FEATURE_CATALOG.
export const FEATURE_LABELS = {
  war_room: "War Room Dispatch",
  gps_tracking: "GPS Tracking",
  job_dockets: "Digital Job Dockets",
  driver_app: "Driver App",
  basic_reporting: "Basic Reporting",
  sos_emergency: "SOS Emergency",
  contractor_supplier_portal: "Contractor & Supplier Portal",
  batching_integration: "Batching System Integration",
  advanced_reporting: "Advanced Reporting",
  multi_plant: "Multiple Plant Support",
  custom_branding: "Custom Branding",
  priority_support: "Priority Support",
  api_access: "API Access",
};

// Route → feature it requires. Routes not listed are always available.
export const ROUTE_FEATURE = {
  "/war-room": "war_room",
  "/dispatch": "war_room",
  "/orders": "war_room",
  "/map": "gps_tracking",
  "/dockets": "job_dockets",
  "/drivers": "driver_app",
  "/reports": "basic_reporting",
  "/daily-summary": "basic_reporting",
  "/partners": "contractor_supplier_portal",
  "/pump-companies": "contractor_supplier_portal",
  "/haulage": "contractor_supplier_portal",
  "/batcher": "batching_integration",
  "/batching": "batching_integration",
  "/settings/link": "batching_integration",
  "/executive": "advanced_reporting",
  "/plants": "multi_plant",
};

// org.features is undefined for legacy/full-access orgs → everything unlocked.
export const makeHasFeature = (org, user) => (key) => {
  if (!key) return true;
  if (user?.is_super_admin) return true;
  const feats = org?.features;
  if (!Array.isArray(feats)) return true; // no tier assigned = full access
  return feats.includes(key);
};
